var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTextFile = function SvgTextFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M807.52 323.52 655.2 180.3A152 152 0 0 0 551.06 139H258.67a74.6 74.6 0 0 0-74.6 74.59v596.78a74.6 74.6 0 0 0 74.6 74.6h522.15a74.58 74.58 0 0 0 74.59-74.6V434.29a152.05 152.05 0 0 0-47.89-110.77M686 497.3H548.4v254h-43.9v-254H367.1v-37.92H686Zm139-100H655.36a74.58 74.58 0 0 1-74.6-74.59V167.75l244.15 229.49Z"
  })));
};
export default SvgTextFile;